import classNames from 'classnames';
import { FC, PropsWithChildren } from 'react';

import { IcCloseIcon } from '@gem/icons';
import { IconButton } from '@gem/ui-kit';

import styles from './BottomPopup.styles.m.css';

interface IBottomPopupProps {
  className?: string;
  onClose?(): void;
}
export const BottomPopup: FC<PropsWithChildren<IBottomPopupProps>> = (props) => {
  const { onClose, className, children } = props;

  return (
    <div className={classNames(styles.container, className)}>
      <IconButton
        className={styles.close}
        Icon={IcCloseIcon}
        onClick={onClose}
      />
      {children}
    </div>
  );
};
